import { useFeatureFlagEnabled } from 'posthog-js/react'

export const useFeatureEnabled = (feature: string) => {
  if (import.meta.env.VITE_ENV !== 'production') {
    return true
  }

  return useFeatureFlagEnabled(feature)
}
